import {BlacklistVin} from './blacklist-vin.model';

export class BlacklistList {
  dataList: BlacklistVin[];
  page: number;
  pageCount: number;
}
